module.exports = __webpack_public_path__ + "img/add-other-length-table-icon.29d664a0.svg";